import type { TranslationTag } from '@ps/web-core-intl';
import { AttributeKey } from '@ps/web-poker-tile-mappers';
import { Translation } from '@ps/web-shared-components';
import type { ReactNode } from 'react';
import React from 'react';

import { formatTournamentAttr } from '@swf/poker';

import type { Step, StepKey } from '../types';
import { StepKeyName } from '../types';

import {
  TXTCLI_Gold_Pass,
  TXTCLI_Prize_pool,
  TXTCLI_Step_N0_ticket,
  TXTCLI_Top_Prize_1
} from './prizePool.messages.json';

interface StepTournamentAttributes {
  formattedPrizePool: string;
}

const ATTRIBUTE_KEY_MAP: Partial<{
  [K in AttributeKey]: keyof StepTournamentAttributes;
}> = {
  [AttributeKey.prizePool]: 'formattedPrizePool'
};

const getFormattedPrizePool = (
  step: Step,
  locale: string,
  isPlayMoney: boolean,
  timeZone: string
) => {
  const formattedAttr = formatTournamentAttr(
    step,
    locale,
    isPlayMoney,
    timeZone,
    ATTRIBUTE_KEY_MAP
  );

  return formattedAttr.formattedPrizePool;
};

export const getPrizePoolDisplayValue = (
  key: StepKey,
  step: Step,
  locale: string,
  isPlayMoney: boolean,
  timeZone: string
): string | ReactNode => {
  switch (key) {
    case StepKeyName.step4:
      return <Translation {...TXTCLI_Gold_Pass} />;
    case StepKeyName.step2SNG:
      return <Translation {...TXTCLI_Step_N0_ticket} values={{ 0: 3 }} />;
    default:
      return getFormattedPrizePool(step, locale, isPlayMoney, timeZone);
  }
};

export const getPrizePoolLabel = (stepKey: StepKey): TranslationTag =>
  stepKey === StepKeyName.step2Scheduled || stepKey === StepKeyName.step3
    ? TXTCLI_Prize_pool
    : TXTCLI_Top_Prize_1;
